import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

const routes: Routes = [
  {
    path: 'merchants/:merchantId',
    children: [
      {path: 'waterfee', loadChildren: () => import('./query/query.module').then(m => m.QueryModule) },
      {path: 'account', loadChildren: () => import('./account/account.module').then(m => m.AccountModule) },
      {path: 'outlets', loadChildren: () => import('./outlets/outlets.module').then(m => m.OutletsModule) },
      {path: 'invoice', loadChildren: () => import('./invoice/invoice.module').then(m => m.InvoiceModule) },
      {path: 'page', loadChildren: () => import('./page/page.module').then(m => m.PageModule) },
      {path: 'repair', loadChildren: () => import('./repair/repair.module').then(m => m.RepairModule) },
      {path: 'complain', loadChildren: () => import('./complain/complain.module').then(m => m.ComplainModule) }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
